export default "__VITE_ASSET__7NEqITW0__"